import { render, staticRenderFns } from "./meridianpage.vue?vue&type=template&id=4b104185&scoped=true&"
import script from "./meridianpage.vue?vue&type=script&lang=js&"
export * from "./meridianpage.vue?vue&type=script&lang=js&"
import style0 from "./meridianpage.vue?vue&type=style&index=0&id=4b104185&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b104185",
  null
  
)

export default component.exports